"use client";
import "@/assets/css-search/search.css";
import { categories } from "@/mockData/categories";
import { faBars, faChevronDown, faPhone, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faGooglePlus, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Image from 'next/image';
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";

function MainHeader({ isMobileOrTablet, dataCategory }) {
    const category = dataCategory?.length > 0 ? dataCategory : categories;
    const [keyword, setKeyword] = useState("");
    const router = useRouter();
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const searchInputRef = useRef(null);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [windowWidth, setWindowWidth] = useState(0);

    const closeAllOverlays = () => {
        setMobileMenuOpen(false);
        setIsSearchOpen(false);
        setOpenDropdown(null);
    };

    const toggleMobileMenu = (e) => {
        e.preventDefault();
        setMobileMenuOpen(!isMobileMenuOpen);
        if (isMobileMenuOpen) {
            setOpenDropdown(null);
        }
    };

    const handleDropdownClick = (e, categoryId) => {
        e.preventDefault();
        setOpenDropdown(openDropdown === categoryId ? null : categoryId);
    };

    const openSearch = () => setIsSearchOpen(true);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);

        if (typeof window !== 'undefined') {
            setWindowWidth(window.innerWidth);
            window.addEventListener('resize', handleResize);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, []);

    const handleSearch = () => {
        if (keyword.trim()) {
            router.push(`/tim-kiem?keyword=${keyword}`);
            setKeyword("");
            closeAllOverlays();
        }
    };
    const handleSearchChange = (e) => setKeyword(e.target.value);
    const handleKyDown = (e) => {
        if (e.key === "Enter") handleSearch();
    };

    useEffect(() => {
        if (isSearchOpen) {
            setTimeout(() => searchInputRef.current?.focus(), 300);
        }
    }, [isSearchOpen]);

    useEffect(() => {
        if (isMobileMenuOpen || isSearchOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isMobileMenuOpen, isSearchOpen]);

    return (
        <>
            <div id="search-overlay" className={`search-overlay ${isSearchOpen ? 'show' : ''}`}>
                <span className="search-overlay-close" onClick={closeAllOverlays}>&times;</span>
                <div className="search-overlay-content">
                    <input ref={searchInputRef} type="text" className="search-overlay-input" placeholder="Bạn muốn tìm gì..." value={keyword} onChange={handleSearchChange} onKeyDown={handleKyDown} />
                    <FontAwesomeIcon icon={faSearch} className="search-overlay-icon" onClick={handleSearch} />
                </div>
            </div>

            <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'show' : ''}`}>
                <div className="mobile-menu-header">
                    <span className="mobile-menu-close" onClick={toggleMobileMenu}>&times;</span>
                </div>
                <div className="mobile-menu-body">
                    <ul className="nav navbar-nav navbar-main">
                        {category?.map((itemCategory, index) => {
                            const safeKey =
                            itemCategory?.id ||
                            itemCategory?.slug ||
                            itemCategory?.urlName ||
                            `cat-mobile-${index}`;

                            return (
                                <li key={safeKey} className={`nav-item dropdown ${openDropdown === itemCategory.id ? 'open' : ''}`}>
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        href={`${itemCategory?.urlName}`}
                                        onClick={(e) => itemCategory.topics.length > 1 ? handleDropdownClick(e, itemCategory.id) : closeAllOverlays()}
                                    >
                                        <span>{itemCategory.name}</span>
                                        {itemCategory.topics.length > 1 && (
                                            <FontAwesomeIcon icon={faChevronDown} className="fa-chevron-down" />
                                        )}
                                    </Link>
                                    {itemCategory.topics.length > 1 && (
                                        <ul className="dropdown-menu">
                                            {itemCategory?.topics.map((itemTopics) => (
                                                (itemTopics.name.toLowerCase() === itemCategory.name.toLowerCase() ? null :
                                                    <li key={itemTopics?.id}><Link href={`${itemTopics?.urlName}`} onClick={closeAllOverlays}>{itemTopics?.name}</Link></li>
                                                )
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>

            <header id="this-is-top">
                <div className="container-fluid">
                    <div className="topmenu row col-sm-offset-3 col-lg-offset-3 ">
                        <nav className="col-lg-4 col-md-4 col-sm-4"><a href="#">Tra cứu thông tin hàng hóa</a></nav>
                        <nav className="col-lg-4 col-md-4 col-sm-4"><a href="#">Tính cước phí vận chuyển</a></nav>
                        <nav className="col-lg-4 col-md-4 col-sm-4 md:text-left">
                            <Link href="https://www.facebook.com/ChanhxePhuQuoc/"
                                aria-label="Facebook của Chành Xe Phú Quốc"
                            >
                                {/* THAY THẾ FACEBOOK ICON */}
                                <FontAwesomeIcon icon={faFacebook} />
                            </Link>
                            <Link href="https://www.youtube.com/@muoituyenvlog334"
                                aria-label="Kênh YouTube Mười Tuyền Vlog"
                            >
                                {/* THAY THẾ YOUTUBE ICON */}
                                <FontAwesomeIcon icon={faYoutube} />
                            </Link>
                            <Link href="mailto:tuyennguyen@conruabien.vn"
                                aria-label="Gửi email tới tuyenguyen@conruabien.vn"
                            >
                                <FontAwesomeIcon icon={faGooglePlus} />
                            </Link>
                            <Link href="tel:0945000006"
                                aria-label="Gọi số điện thoại 0945 000 006"
                            >
                                <FontAwesomeIcon icon={faPhone} />: 0945 000 006
                                <span className="sr-only">0945 000 006</span>
                            </Link>
                        </nav>
                    </div>
                    <div className="row header">
                        <div className="col-sm-3 col-md-3 col-lg-3 custom-logo"><Link href="/"><Image src="/img/logo.avif" alt="logo" width={179.2} height={100.3} priority={true} fetchPriority="high" /></Link></div>
                        <div className="col-sm-9 offset-sm-1 col-md-9 offset-md-2 col-lg-9 offset-lg-2"><div className="text-center"><h2 className="title-header">CHÀNH XE HÀ NỘI - SÀI GÒN - PHÚ QUỐC</h2></div></div>
                    </div>
                    <div className="mobile-search-container">
                        <div className="mobile-search-bar">
                            {/* THAY THẾ MOBILE SEARCH ICON */}
                            <FontAwesomeIcon icon={faSearch} className="mobile-search-icon" onClick={handleSearch} />
                            <input
                                type="text"
                                className="mobile-search-input"
                                placeholder="Tìm kiếm bài viết..."
                                value={keyword}
                                onChange={handleSearchChange}
                                onKeyDown={handleKyDown}
                            />
                        </div>
                    </div>
                    <div id="main-menu-bg" />
                    <nav className="main-menu navbar-main-slide">
                        <a id="menu-open"
                            href="#"
                            onClick={toggleMobileMenu}
                            aria-label="Mở menu">
                            <FontAwesomeIcon icon={faBars} />
                        </a>

                        <ul className="nav navbar-nav navbar-main">
                            {category?.map((itemCategory, index) => {
                                const safeKey =
                                    itemCategory?.id ||
                                    itemCategory?.slug ||
                                    itemCategory?.urlName ||
                                    `cat-main-${index}`;

                                return (
                                    <li
                                        className={`dropdown ${openDropdown === itemCategory.id ? 'open' : ''}`}
                                        key={safeKey}
                                    >
                                        <Link
                                            className="dropdown-toggle border-hover-color1"
                                            href={`${itemCategory?.urlName}`}
                                            onClick={(e) => itemCategory.topics.length > 1 ? handleDropdownClick(e, itemCategory.id) : closeAllOverlays()}
                                        >
                                            {itemCategory?.name}
                                            {itemCategory?.topics.length > 1 && (<FontAwesomeIcon icon={faChevronDown} className="fa-chevron-down" />)}
                                        </Link>

                                        {itemCategory.topics.length > 1 && (
                                            <ul className="dropdown-menu">
                                                {itemCategory?.topics
                                                    ?.filter(t => t.name?.toLowerCase() !== itemCategory.name?.toLowerCase())
                                                    .map((itemTopics, index) => {
                                                        const safeTopicKey =
                                                        itemTopics?.id ||
                                                        itemTopics?.slug ||
                                                        itemTopics?.urlName ||
                                                        `topic-desktop-${index}`;

                                                        return (
                                                        <li key={safeTopicKey}>
                                                            <Link
                                                            href={`${itemTopics?.urlName}`}
                                                            onClick={closeAllOverlays}
                                                            >
                                                            {itemTopics?.name}
                                                            </Link>
                                                        </li>
                                                        );
                                                    })}
                                            </ul>
                                        )}
                                    </li>
                                )
                            } )}
                            <li>
                                <div className="custom-search">
                                    <input
                                        type="text"
                                        className="custom-input"
                                        placeholder="Tìm kiếm..."
                                        value={keyword}
                                        onChange={handleSearchChange}
                                        onKeyDown={handleKyDown}
                                    />
                                    <span
                                        className="custom-icon"
                                        onClick={
                                            (windowWidth >= 798 && windowWidth <= 960)
                                                ? openSearch
                                                : handleSearch
                                        }
                                    >
                                        <FontAwesomeIcon icon={faSearch} />
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        </>
    );
}

export default MainHeader;
